import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var Parallax = /*#__PURE__*/function () {
  function Parallax() {
    _classCallCheck(this, Parallax);

    this.enable = false;
    this.force = 2;
    this.smooth = 10;
  }

  _createClass(Parallax, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.force !== undefined) {
        this.force = data.force;
      }

      if (data.smooth !== undefined) {
        this.smooth = data.smooth;
      }
    }
  }]);

  return Parallax;
}();